export const SIDEBAR_COLLAPSED_COOKIE = 'auctogon:sidebar-collapsed';

/**
 * The tier at which the nav rail is pinned rather than opened as a drawer
 * (BL-1439). Matches Tailwind's default `md` breakpoint, which is what actually
 * performs the rail/drawer switch — `DashboardShell` does it in CSS so there is
 * no first-paint flash, and this string exists only for the ONE thing CSS
 * cannot do: close an already-open drawer when the viewport grows past the
 * boundary. The drawer portals to `document.body`, so the bar's own `md:hidden`
 * cannot hide it.
 *
 * DELIBERATELY NOT `PHONE_CARD_BREAKPOINT` (BL-1438), despite both being 768.
 * That one is a CONTAINER width — `DataTableV2` reads `containerWidth <
 * mobileCardBreakpoint` — while this is a VIEWPORT boundary. `ui-standards.md`
 * (Misc → Responsive) draws exactly that line: "Plain `md:`/`lg:` stay correct
 * for things that genuinely track the window (the rail's own collapse, the tab
 * strip)." Same number, two different measurement axes; one shared export would
 * blur them. Confirmed with Michael Lawrie, 2026-09-03.
 */
export const SIDEBAR_PINNED_VIEWPORT_QUERY = '(min-width: 768px)';
